import { TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { UserResolver } from '@hmax-order/frontend/user';
import { cfgRoutes } from './cfg.routes';
import { CfgResolver } from './resolver/cfg.resolver';

@NgModule({
  imports: [RouterModule.forChild(cfgRoutes)],
  providers: [CfgResolver, TitleCasePipe, UserResolver],
})
export class CfgModule {}
